// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".adm-safe-area {\n  --multiple: var(--adm-safe-area-multiple, 1);\n  display: block;\n  width: 100%;\n}\n.adm-safe-area-position-top {\n  padding-top: calc(env(safe-area-inset-top) * var(--multiple));\n}\n.adm-safe-area-position-bottom {\n  padding-bottom: calc(env(safe-area-inset-bottom) * var(--multiple));\n}\n", ""]);
// Exports
module.exports = exports;
